// Shared units library (moved from UnitManagement so the Budget Estimation
// materials picker can reuse the same list). name + default price.
export const unitLibrary = [
    { name: "cavo lan (MT)", price: 2.10 },
    { name: "CAVO 4X0,50", price: 0.61 },
    { name: "CAVO 2X0,75", price: 0.50 },
    { name: "CAVO 1X1,5 ROSSO", price: 0.28 },
    { name: "CAVO 1X1,5 NERO", price: 0.28 },
    { name: "CAVO 1X1,5ARANCIO", price: 0.28 },
    { name: "N°M12", price: 17.70 },
    { name: "N° M12 8 POOLI", price: 27.50 },
    { name: "rj45", price: 7.50 },
    { name: "morsettiera wago fusibilata +barra din", price: 1.00 },
    { name: "puntalini", price: 0.10 },
    { name: "RELAY", price: 5.00 },
    { name: "RELAY TEMPORIZZATO", price: 24.00 },
    { name: "faston maschio maschio", price: 0.04 },
    { name: "faston femmina", price: 0.04 },
    { name: "CONNETTORE MASCHIO 3 POLI", price: 0.59 },
    { name: "CONNETTORE FEMMINA 3 POLI", price: 0.57 },
    { name: "CONNETTORE MASCHIO 2 POLI", price: 0.39 },
    { name: "CONNETTORE FEMMINA 2 POLI", price: 0.37 },
    { name: "CONNETTORE MASCHIO 1 POLI", price: 0.16 },
    { name: "CONNETTORE FEMMINA 1 POLI2", price: 0.14 },
    { name: "CONNETTORE ALIMENTAZIONE ENOBU", price: 15.00 },
    { name: "CAVO ALIMENTAZIONE ENOBU (ROSSO-NERO-ARANCIO)", price: 0.84 },
    { name: "CONNETTORE ALIMENTAZIONE SWITCH", price: 18.62 },
    { name: "CAVO ALIMENTAZIONE SWITCH", price: 1.00 },
    { name: "CONNETTORE SEGNALI ENOBU", price: 25.00 },
    { name: "CAVO SEGNALI ENOBU", price: 1.00 },
    { name: "STAFFE CARTELLI INDICATORI", price: 40.00 },
    { name: "STAFFE LCD", price: 160.00 },
    { name: "STAFFE LCD 2", price: 77.00 },
    { name: "SCATOLE CONTAPASSEGGERI", price: 10.00 },
    { name: "STAFFA RINFORZO ENOBU", price: 5.00 },
]

export default unitLibrary
